"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var e,
    r = require("react"),
    t = (e = r) && "object" == typeof e && "default" in e ? e["default"] : e,
    u = require("react-dom");

exports["default"] = function (e) {
  var n = e.children,
      c = e.type,
      o = void 0 === c ? "reach-portal" : c,
      a = r.useRef(null),
      l = r.useRef(null),
      d = r.useState()[1];
  return r.useLayoutEffect(function () {
    var e = a.current.ownerDocument;
    return l.current = null == e ? void 0 : e.createElement(o), e.body.appendChild(l.current), d({}), function () {
      l.current && l.current.ownerDocument && l.current.ownerDocument.body.removeChild(l.current);
    };
  }, [o]), l.current ? u.createPortal(n, l.current) : t.createElement("div", {
    ref: a
  });
};